import type { CampaignOut, ConditionSpecIn } from "../types";

const EXCLUDED_STATUSES = new Set(["archived", "expired"]);

const conditionReferencesSegment = (
  condition: ConditionSpecIn,
  segmentId: string,
): boolean =>
  condition.type === "user_in_segment" && condition.params?.segment_id === segmentId;

/**
 * Returns campaigns that currently reference `segmentId` via a
 * `user_in_segment` condition in eligibility or any step. Archived and
 * expired campaigns are excluded — they're neither current nor future.
 */
export const campaignsUsingSegment = (
  campaigns: CampaignOut[],
  segmentId: string,
): CampaignOut[] => {
  if (!segmentId) return [];

  return campaigns.filter((campaign) => {
    if (EXCLUDED_STATUSES.has(campaign.status)) return false;

    const inEligibility = (campaign.eligibility_conditions ?? []).some((c) =>
      conditionReferencesSegment(c, segmentId),
    );
    if (inEligibility) return true;

    return (campaign.steps ?? []).some((step) =>
      (step.conditions ?? []).some((c) => conditionReferencesSegment(c, segmentId)),
    );
  });
};
